var map = {
	"./img-profile-UGMA.svg": 487,
	"./img-profile-advisor.svg": 161,
	"./img-profile-default-admin.svg": 231,
	"./img-profile-default.svg": 123,
	"./img-profile-institution.svg": 488,
	"./img-profile-joint.svg": 489,
	"./img-profile-trust.svg": 490
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 235;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user ^\.\/.*\.svg$
// module id = 235
// module chunks = 1